/** @format */

import { NO_ERRORS_SCHEMA, NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { HomefieldButtonModule } from '@homefield';
import { QuickviewCtaComponent } from './quickview-cta.component';

@NgModule({
	imports: [CommonModule, HomefieldButtonModule],
	declarations: [QuickviewCtaComponent],
	exports: [QuickviewCtaComponent],
	schemas: [NO_ERRORS_SCHEMA]
})
export class QuickviewCtaModule {}
